import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthRedirect() {
  const { currentUser, role } = useAuth();

  if (currentUser) {
    // If user is logged in, redirect based on role
    return <Navigate to={role === 'admin' ? '/admin' : '/dashboard'} replace />;
  }

  // If not logged in, redirect to login
  return <Navigate to="/login" replace />;
}
